import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 480,
      borderRadius: theme.shape.borderRadiusLarge,
    },
    dialogContent: {
      padding: theme.spacing(0, 2, 3, 2),
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      background: theme.palette.common.white,
      borderRadius: theme.shape.borderRadiusSemiLarge,
      border: theme.shape.borderGray60,
      margin: theme.spacing(2, 2, 0, 2),
    },
    itemContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1, 2),
      '& + &': {
        borderTop: theme.shape.borderGray60,
      },
    },
    item: {
      flex: 1,
      margin: 0,
    },
  }),
  { name: 'FormatSelectionPopup' }
);
